<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>远程预付费</el-breadcrumb-item>
			<el-breadcrumb-item>月账单</el-breadcrumb-item>
		</el-breadcrumb>

			<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search" ref='searchbox' @submit.native.prevent>
			<el-form-item label="搜索：">
				<el-input placeholder="请输入计量点名称"  @keyup.enter.native="search"  v-model="formInline.meterPointName" size="small"></el-input>
			</el-form-item>
      <el-form-item >
				<el-input placeholder="请输入计量点地址"  @keyup.enter.native="search"  v-model="formInline.meterPoint" size="small"></el-input>
			</el-form-item>
      <el-form-item>
        <el-date-picker size="small" v-model="formInline.month" type="month" value-format="yyyy-MM" placeholder="选择月">
        </el-date-picker>
      </el-form-item>
			<el-form-item v-if="user.username == 'admin'" label="所属部门">
				<el-select v-model="formInline.departmentId" placeholder="请选择"  size="small">
				   <el-option
				     v-for="item in treeDate"
				     :key="item.id"
				     :label="item.departmentName"
				     :value="item.id">
				   </el-option>
				 </el-select>
			</el-form-item>
			<el-form-item>
			<!-- 	<prems-button size="mini"  label="生成账单" perms="sys:menu:add" @click="createBill" />
				<prems-button size="mini"  label="生成数据" perms="sys:menu:add" @click="createData" />
				<prems-button size="mini"  label="生成计算账单" perms="sys:menu:add" @click="createComputData" /> -->
			</el-form-item>


      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" icon="el-icon-download" @click="exportdata">导出</el-button>
      </el-form-item>
		</el-form>
		<!-- 数据列表 -->
		<el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
		 style="width: 100%;" ref="tablelist" stripe>

			<el-table-column prop="meterPointName" label="计量点名称" width="200"  fixed="left">
			</el-table-column>
      <el-table-column prop="meterPointAddress" label="计量点地址" width="140" >
      </el-table-column>
      <el-table-column prop="payDay" label="费用账期" >
      </el-table-column>
      <el-table-column prop="payDayCost" label="电表账期费用(元)" width="120"  >
      </el-table-column>

      <el-table-column prop="usedCost" label="已扣费费用(元)" width="120">
      </el-table-column>

      <el-table-column prop="payDayUsedCost" label="账期扣费费用(元)" width="120">
      </el-table-column>

      <el-table-column prop="payDayReading" label="账期电表读数(kWh)" width="130">
      </el-table-column>

      <el-table-column prop="lastReading" label="上期电表读数(kWh)" width="130">
      </el-table-column>

      <el-table-column prop="magnification" label="倍率" width="80">
      </el-table-column>
      <el-table-column label="是否预付费" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.isPay">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="unitPrice" label="单价(元 )" width="100">
      </el-table-column>
      <el-table-column prop="monthUsed" label="本月用能(kWh)" width="130">
      </el-table-column>
      <el-table-column prop="avgUsed" label="日均用量(kWh)" width="120">
      </el-table-column>

      <el-table-column prop="avgCost" label="日均费用(元)" width="120">
      </el-table-column>
      <el-table-column prop="lastBalance" label="上期余额(元)" width="120">
      </el-table-column>
      <el-table-column prop="lastAllowance" label="上期余量(kWh)" width="120">

      </el-table-column>
      <el-table-column prop="nextAllowance" label="下期可用余量(kWh)" width="130">

      </el-table-column>
      <el-table-column prop="money" label="充值金额(元)" width="120">
      </el-table-column>
      <el-table-column prop="nowBalance" label="本期余额(元)" width="120">
      </el-table-column>
      <el-table-column prop="nowAllowance" label="本期余量(kWh)" width="120">
      </el-table-column>




			<!-- <el-table-column align="center" label="操作" width="150">
				<template slot-scope="scope">
					<el-button type="success" size="mini" icon="el-icon-download" :loading="loadStatus && currid == scope.row.id"    @click="exportdata(scope.$index, scope.row)">下载</el-button>
				</template>
			</el-table-column> -->
		</el-table>

		<Pagination v-bind:child-msg="pageparm" @callFather="callFather" v-if="showPage" ></Pagination>


	</div>
</template>

<script>
	import { getMonthlyBillList,generateMonthlyBill,generateESPowerData,calMeterInfoPrice,initData,exportMonthData,downloadMonthlyBill  } from '../../api/userMG.js'
   import { getDepartmentTerminalInfoLis } from '../../api/energyMG'
	import { timestampToTime} from '@/utils/util'
	import PremsButton from "@/views/permission/PreButtom";
	import Pagination from '../../components/Pagination'
	export default{
		data(){
			return{
				loading:false,
				showPage:true,
				loadStatus:false,
        treeDate:[],
				currid:'',
				formInline:{
					meterPointName:'',
					currentPage: 1,
					pageSize: 10,
          departmentId:"",
          meterPoint:"",
          month:''
				},
        loadLoadin:false,
        user:{},
        loadLoadin:false,
				dateData:[],
				dataList:[],
				pageparm:{
					currentPage: 1,
					pageSize:10,
					total: 0
				}
			}
		},
		// 注册组件
		components: {
			Pagination,
			PremsButton
		},
		created(){
       this.user = JSON.parse(sessionStorage.getItem('userdata'))
			this.getData()
       this.getJzData();
		},
		methods: {


			exportdata(idx,row){
				this.loadStatus = true

				// let param = {
				// 	month:"",
    //       meterPointName:"",
    //       meterPointAddress:""
				// }
        let parm = {
          meterPointName:this.formInline.meterPointName,
          departmentId:this.formInline.departmentId,
          month:this.formInline.month,
          meterPoint:this.formInline.meterPoint
        }

				exportMonthData(parm).then(res => {
					var blob = new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
					var downloadElement = document.createElement('a');
				　　var href = window.URL.createObjectURL(blob); //创建下载的链接
				　　downloadElement.href = href;
				　　downloadElement.download = 'result.xls'; //下载后文件名
				　　document.body.appendChild(downloadElement);
				　　downloadElement.click(); //点击下载
				　　document.body.removeChild(downloadElement); //下载完成移除元素
				　　window.URL.revokeObjectURL(href); //释放掉blob对象
					this.loadStatus = false
					this.$message.success('表格生成成功！正在下载')
				}).catch(err => {
					this.loadStatus = false
					this.$message({
						message:'下载失败！',
						type:'error',
						showClose:true
					})
				})
			},
			search() {
				this.pageparm.currentPage = 1
				this.formInline.currentPage = 1
				this.showPage = false
				this.getData()
				this.$nextTick(()=>{
					this.showPage = true
				})
			},
			//生成计算账单
			createComputData(){

				calMeterInfoPrice().then(res => {
					if(res.status == 1){
						this.$message.success('操作成功！')
						this.getData()
					}
				})
			},
      //获取集中器信息
      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.treeDate = res.data.menuDepList

      				resolve(res.data.terIds)
      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },


			//生成账单
			createBill(){

				generateMonthlyBill().then(res => {
					if(res.status == 1){
						this.$message.success('操作成功！')
						this.getData()
					}
				})
			},
			//生成数据
			createData(){
				generateESPowerData().then(res => {
					if(res.status == 1){
						this.$message.success('操作成功！')
					}
				})
			},
			getData(){
				this.loading = true
				getMonthlyBillList(this.formInline).then( res =>{
					this.loading = false
					if(res.status == 1){
						this.dataList = res.data.data
						this.pageparm.currentPage = this.formInline.currentPage
						this.pageparm.pageSize = this.formInline.pageSize
						this.pageparm.total = res.data.totalCount
					}
				})
				.catch(err => {
					this.loading = false
					this.$message.error('获取数据失败，请稍后再试！')
				})
			},
			// 分页插件事件
			callFather(parm) {
				this.formInline.currentPage = parm.currentPage
				this.formInline.pageSize = parm.pageSize
				this.getData()
			},
			getDate(val){
				this.formInline.startTime = timestampToTime(this.dateData[0]).substring(0, 10)
				this.formInline.endTime = timestampToTime(this.dateData[1]).substring(0, 10)
				this.getData()
			}
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/prepayment/bill.vue